module.exports = {
  accent: '#5beeb6',
  siteBg: '#fdfdfd',
  title: '#444',
  subTitle: '#757575',
}
